import { fetchBluetoothPairingGuides, } from '@gn-audio/core/api/knowledge-base/fetch-bluetooth-paiting-guides';
var SupportPageSection;
(function (SupportPageSection) {
    SupportPageSection["BluetoothPairingGuides"] = "BTPG";
    SupportPageSection["FrequentlyAskedQuestions"] = "FAQ";
    SupportPageSection["TechnicalDocuments"] = "Tech";
})(SupportPageSection || (SupportPageSection = {}));
var SolutionGroupCardComponentController = (function () {
    function SolutionGroupCardComponentController($q) {
        this.$q = $q;
        this.currentImageIndex = 0;
        this.hasSupportPage = false;
        this.hasPublicPage = false;
        this.supportPageSection = SupportPageSection;
    }
    SolutionGroupCardComponentController.prototype.$onInit = function () {
        this.hasSupportPage = Boolean(this.group && this.group.supportPageUrl);
        this.hasPublicPage = Boolean(this.group && this.group.pageUrl);
        if (this.hasSupportPage) {
            this.loadBluetoothPairingGuides(this.group.groupId);
        }
    };
    SolutionGroupCardComponentController.prototype.getSupportPageSectionUrl = function (section) {
        if (!this.hasSupportPage) {
            return '';
        }
        switch (section) {
            case SupportPageSection.TechnicalDocuments:
            case SupportPageSection.FrequentlyAskedQuestions:
                return this.group.supportPageUrl + "#/" + section + "#" + this.group.sku;
            case SupportPageSection.BluetoothPairingGuides:
                return this.group.supportPageUrl + "/" + this.group.sku + "/get-started#" + section;
            default:
                return '';
        }
    };
    Object.defineProperty(SolutionGroupCardComponentController.prototype, "images", {
        get: function () {
            var _a;
            return ((_a = this.group) === null || _a === void 0 ? void 0 : _a.images) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SolutionGroupCardComponentController.prototype, "hasImages", {
        get: function () {
            var _a;
            return ((_a = this.images) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SolutionGroupCardComponentController.prototype, "hasBluetoothPairingGuides", {
        get: function () {
            return Array.isArray(this.guides) ? this.guides.length > 0 : undefined;
        },
        enumerable: false,
        configurable: true
    });
    SolutionGroupCardComponentController.prototype.loadBluetoothPairingGuides = function (id) {
        var _this = this;
        this.$q.when(fetchBluetoothPairingGuides(id))
            .then(function (guides) { _this.guides = guides || []; });
    };
    SolutionGroupCardComponentController.$inject = ['$q'];
    return SolutionGroupCardComponentController;
}());
export var SolutionGroupCardComponent = {
    bindings: {
        group: '<',
        thirdPartyDevices: '<',
    },
    controller: SolutionGroupCardComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/solutiongroupcard',
};
